import { useEffect, useRef, useState } from "react";

// Vídeo de uma cena: começa a baixar quando "warm", só toca com o slide ativo e assentado (fora da transição),
// pausa com a aba em segundo plano e volta ao início 900 ms depois que o slide sai da tela.
// "variant" troca quando o recorte muda (horizontal x vertical), para refazer o ciclo no novo <video>.
export default function useSceneVideo({ active, settled, warm, enabled = true, variant }) {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  // preload="auto" entra depois de montado: o Chrome retoma o download ao ver o atributo mudar;
  // o Safari ignora a troca, então load() só é chamado se nada começou a baixar.
  useEffect(() => {
    const video = videoRef.current;
    if (!warm || !enabled || !video) return undefined;
    const timer = window.setTimeout(() => {
      if (video.networkState !== HTMLMediaElement.NETWORK_LOADING && video.readyState === HTMLMediaElement.HAVE_NOTHING) {
        video.load();
      }
    }, 250);
    return () => window.clearTimeout(timer);
  }, [warm, enabled, variant]);

  useEffect(() => {
    const video = videoRef.current;
    if (!enabled || !video) return undefined;
    if (active && settled) {
      if (!document.hidden) video.play().catch(() => {});
      return undefined;
    }
    video.pause();
    if (!active) {
      const timer = window.setTimeout(() => {
        video.currentTime = 0;
        setPlaying(false);
      }, 900);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [active, settled, enabled, variant]);

  useEffect(() => {
    const onVisibility = () => {
      const video = videoRef.current;
      if (!video) return;
      if (document.hidden) video.pause();
      else if (active && settled) video.play().catch(() => {});
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, [active, settled]);

  return { videoRef, playing, onPlaying: () => setPlaying(true) };
}
